import { render, staticRenderFns } from "./UserAccountDetailsCompanyInformation.vue?vue&type=template&id=6856a58e&"
import script from "./UserAccountDetailsCompanyInformation.vue?vue&type=script&lang=js&"
export * from "./UserAccountDetailsCompanyInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports